import React, { useState } from 'react'
import OnVisible from 'react-on-visible'
import { Section, TabIconCollection, Image } from 'newComponents'
import './styles.scss'

const TabSelect = (props) => {
  const { data } = props
  const { primary, items } = data
  const { content, title, new_rendering: newRendering } = primary
  // state
  const [activeTab, setActiveTab] = useState(items[0].tab_title.text)
  const [activeIcons, setActiveIcons] = useState(items[0].icons)
  const [activeContent, setActiveContent] = useState(items[0].tab_content.html)
  const [activeImage, setActiveImage] = useState(items[0].tab_image?.url || false)
  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html

  const handleOnClick = (event, item) => {
    const { tab_content: tabContent, tab_title: button, icons, tab_image: image } = item
    event.preventDefault()
    if (activeTab !== button.text) {
      setActiveTab(button.text)
      setActiveIcons(icons)
      setActiveContent(tabContent.html)
      setActiveImage(image?.url || false)
    }
  }
  // factor in images for tabs and 'new rendering'
  return (
    <OnVisible className={`tab-select ${newRendering ? 'new-rendering' : ''}`}>
      <Section>
        {titleHtml && <div className="tab-select-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
        {contentHtml && <div className="tab-select-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
        <div className="tab-select-container">
          {items.map((item) => {
            const { tab_title: tabTitle } = item
            const tabTitleText = tabTitle?.text
            const isActiveTab = tabTitleText === activeTab

            return (
              <button
                type="button"
                className={`tab-select-tab ${isActiveTab ? 'active' : ''}`}
                onClick={(event) => handleOnClick(event, item)}
                key={tabTitleText}
              >
                {tabTitleText && <span className="tab-select-tab-title">{tabTitleText}</span>}
              </button>
            )
          })}
        </div>
        {activeContent && <div className="tab-select-subtitle" dangerouslySetInnerHTML={{ __html: activeContent }} />}
        {activeImage && <Image className="tab-select-image" image={activeImage} />}
        <TabIconCollection icons={activeIcons} textContent={items} />
      </Section>
    </OnVisible>
  )
}
export default TabSelect
